module.exports = __webpack_public_path__ + "static/media/gipsyy-white-transparent.3d18725a.png";